import { render, staticRenderFns } from "./ImmersiveToolbar.vue?vue&type=template&id=57ff5fe5&scoped=true&"
import script from "./ImmersiveToolbar.vue?vue&type=script&lang=js&"
export * from "./ImmersiveToolbar.vue?vue&type=script&lang=js&"
import style0 from "./ImmersiveToolbar.vue?vue&type=style&index=0&id=57ff5fe5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ff5fe5",
  null
  
)

component.options.__file = "ImmersiveToolbar.vue"
export default component.exports